import { Component, OnInit } from '@angular/core';
import { MDBModalRef, MDBModalService } from 'angular-bootstrap-md';
import  {ModalComponent} from '../../Shared/Components/modal/modal.component';
import {ContactModalComponent} from '../../Shared/Components/contact-modal/contact-modal.component';
import { ConfigLoaderService } from 'src/app/Shared/Services/Config/config-loader.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  modalRef!: MDBModalRef; 
  copyright!:string;
  mailText:string = "";


  constructor(
    private modalService: MDBModalService,
    private _configLoaderService: ConfigLoaderService ) { }

  ngOnInit(): void {
    //this.copyright=ConfigLoaderService.settings.AppSettings.copyRight + "All Rights Reserved.For internal use only";
    this.copyright= (new Date()).getFullYear() + " " + ConfigLoaderService.settings.AppSettings.copyRight;
   
  }
  getElementDetails(elementId:string) {

    
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
      data: {
          selectedoffering:  elementId,   
              
      }
    }
    this.modalRef = this.modalService.show(ModalComponent,modalOptions)
  }

  getContactElementDetails() {
    
    const modalOptions = {
      backdrop: true,
      keyboard: true,
      focus: true,
      show: false,
      ignoreBackdropClick: false,
      class: '',
      containerClass: '',
      animated: true,
     
    }
    this.modalRef = this.modalService.show(ContactModalComponent,modalOptions)
  }
  

  Mail(){    
    this.mailText="mailto:asd.support@accenture.com";

    window.location.href = encodeURI(this.mailText);
  }


}
